import { toastr } from 'react-redux-toastr'
import branditRails from '../../../../api/brandit_rails'
import {
  setWarehouseAddressAction,
  setWarehouseAddressesStatusAction,
  setWarehouseAddressesErrorsAction,
  clearWarehouseAddressesErrorsAction
} from './warehouseAddresses.actions'

export const editWarehouseAddress = (id, formData) => async dispatch => {
  try {
    dispatch(setWarehouseAddressesStatusAction('loading'))
    dispatch(clearWarehouseAddressesErrorsAction())

    const { data } = await branditRails.patch(`/warehouse_addresses/${id}`, formData)

    dispatch(setWarehouseAddressAction(data))
    dispatch(setWarehouseAddressesStatusAction('succeeded'))
    toastr.success('Success', 'Warehouse address updated successfully!')

    return data
  } catch (err) {
    const errorMessage = err.response?.data?.message || err.message
    dispatch(setWarehouseAddressesErrorsAction({ message: errorMessage }))
    dispatch(setWarehouseAddressesStatusAction('failed'))
    toastr.error('Error', errorMessage)
    throw err
  }
}
